// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__0_w4M","icon":"footer_icon__6U0Nz","deckPageOverride":"footer_deckPageOverride__CWLM5","notices":"footer_notices__4tMOk","copy":"footer_copy__Rjasx"};